import { TrackedPropertyRelationship } from '../../../graphql.generated';

export const baseUser = {
    loggedIn: true,
    name: '<test-name>',
    email: '<test-email>',
    status: 'valid',
    senderPropertyStatus: '',
    userId: 32503316,
    userUuid: '<user-id>',
    creationDate: '2020-01-26 11:34:01',
    brandPrimary: 'zoopla',
    registrationSources: ['facebook'],
    registered: true
};

export const userWithEmptyTrackedProperties = {
    loggedIn: true,
    name: '<test-name>',
    email: '<test-email>',
    status: 'valid',
    senderPropertyStatus: '',
    userId: 32503316,
    userUuid: '<user-id>',
    creationDate: '2020-01-26 11:34:01',
    brandPrimary: 'zoopla',
    registrationSources: ['facebook'],
    registered: true,
    trackedProperties: {
        items: [],
        total: 0
    }
};

export const userWithTrackedProperties = {
    loggedIn: true,
    name: '<test-name>',
    email: '<test-email>',
    status: 'valid',
    senderPropertyStatus: '',
    userId: 32503316,
    userUuid: '<user-id>',
    creationDate: '2020-01-26 11:34:01',
    brandPrimary: 'zoopla',
    registrationSources: ['facebook'],
    registered: true,
    trackedProperties: {
        items: [
            {
                relationship: TrackedPropertyRelationship['Homeowner'],
                property: {
                    uprn: '68138111',
                    address: {
                        fullAddress:
                            '123456788 Very long street name here, Manchester, MAN12345',
                        uprn: '68138111'
                    }
                },
                permissions: {
                    hasPermissions: false
                }
            }
        ],
        total: 1
    }
};

export const userWithTrackedPropertiesConsented = {
    loggedIn: true,
    name: '<test-name>',
    email: '<test-email>',
    status: 'valid',
    senderPropertyStatus: '',
    userId: 32503316,
    userUuid: '<user-id>',
    creationDate: '2020-01-26 11:34:01',
    brandPrimary: 'zoopla',
    registrationSources: ['facebook'],
    registered: true,
    trackedProperties: {
        items: [
            {
                relationship: TrackedPropertyRelationship['Homeowner'],
                property: {
                    uprn: '68138111',
                    address: {
                        fullAddress:
                            '123456788 Very long street name here, Manchester, MAN12345',
                        uprn: '68138111'
                    }
                },
                permissions: {
                    hasPermissions: true
                }
            }
        ],
        total: 1
    }
};
